import {
  doc,
  setDoc,
  serverTimestamp
} from "firebase/firestore";

import { dbstatus } from "../firebase";
import Cookies from "js-cookie";


export const Create_status_message_qry = async (data) => {

  const { message,contentid } = data || {};

  // ================= VALIDATION =================
  if (!contentid || !contentid.trim()) {
    return { success: false, error: "Missing contentid" };
  }
 if (!message || !message.trim()) {
    return { success: false, error: "Missing message" };
  }
  const sessiontoken = Cookies.get("sessiontoken");
  const guid = Cookies.get("guid");

  if (!sessiontoken) {
    return { success: false, error: "Session expired. Please relogin." };
  }

  if (!guid) {
    return { success: false, error: "Login expired. Please relogin." };
  }

  try {
    const usercity = Cookies.get("city") || "Unknown";
    const userpostcode = Cookies.get("postcode") || "000000";
    const userstate = Cookies.get("state") || "N/A";
    const usercountryname = Cookies.get("country") || "N/A";
    const userlatitude = Cookies.get("latitude") || "0";
    const userlongitude = Cookies.get("longitude") || "0";
    const useraddress = Cookies.get("address") || "Not Available";

    //

    const tablename = "statusmessage";

    const docRef = doc(dbstatus, tablename, contentid);

    await setDoc(
      docRef,
      {
        ...data,
        contentid,
        guid,
        indexnumber: 0,
        sessiontoken,
        like: 0,
        read: 0,
        download: 0,
        copy: 0,
        comment: 0,
        share: 0,
        city: usercity,
        postcode: userpostcode,
        state: userstate,
        country: usercountryname,
        address: useraddress,
        latitude: userlatitude,
        longitude: userlongitude,
        status: true,
        date_time: Date.now(),
      },
      { merge: true }
    );

    return { success: true };

  } catch (err) {

    console.error("❌ Create_status_message_qry:", err);

    return {
      success: false,
      error: err.message || "Firestore operation failed"
    };

  }
};